import axios from 'axios'
const state = {
  TypeProlists: [],
  RcEstatelists: [],
  searchKeword: []
}

const getters = {
  getTypeProlists (state) {
    return state.TypeProlists
  },
  getRcEstatelists (state) {
    return state.RcEstatelists
  },
  getSearchList (state) {
    return state.searchKeword
  }
}

const mutations = {
  setTypeProlists (state, payload) {
    state.TypeProlists = payload
  },
  setRcEstatelists (state, payload) {
    state.RcEstatelists = payload
  },
  setSearchList (state, payload) {
    state.searchKeword = payload
  }
}

const actions = {
  apiTypeProlists (context) {
    // if (payload.method === 'POST') {
    // } else if (payload.method === 'DELETE') {
    // } else { // GET method
    //   alert('11')
    axios.get('/api/estate/TypeProlists')
      .then((response) => {
        // console.log(response.data)
        context.commit('setTypeProlists', response.data)
      })
      .catch((error) => {
        alert(error.response.data.message)
      })
    // }
  },
  apiRcEstatelists (context, payload) {
    axios.get('api/estate/RcEstatelists', {
      params: {
        type: payload.type
      }
    })
      .then((response) => {
        // console.log(response.data)
        for (var i = 0; i < response.data.length; i++) {
          if (typeof response.data[i].images !== 'undefined') {
            response.data[i].images = encodeURI(response.data[i].images)
          }
        }
        // console.log(response.data)
        context.commit('setRcEstatelists', response.data)
      })
      .catch((error) => {
        alert(error.response.data.message)
      })
  },
  apiSearchList (context, payload) {
    axios.get('/api/common/getKeyword', {
      params: {
        keyword: payload.keyword
      }
    })
      .then((response) => {
        // console.log(response.data)
        context.commit('setSearchList', response.data)
      })
      .catch((error) => {
        console.log(error.response.status)
      })
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/main.js